<template>
  <div class="interest_table2024">
    <template v-if="tableData && tableData.length > 1">
      <section class="interest_table_main">
        <div
          v-for="name in types"
          :key="name"
          :ref="`tableWrap-${name}`"
          :class="[`${name}_table_main`]"
          @scroll="handleScroll('table', $event)"
        >
          <div
            v-for="subname in types.filter(n => n === 'normal' || (isShowFixedTableHeader && isScreenCaptureShow))"
            :key="subname"
            :ref="`headerWrap-${name}-${subname}`"
            :class="[`${subname}_header`]"
            @scroll="handleScroll('header', $event)"
          >
            <table :style="{ width: `${tableWidth}em`}">
              <thead>
                <tr>
                  <th
                    v-for="k in tableColumnKeys"
                    :key="k"
                    :style="{
                      width: `${tableColumnWidths[k]}em`,
                      minWidth: `${tableColumnWidths[k]}em`,
                      maxWidth: `${tableColumnWidths[k]}em`
                    }"
                    @click="onClickOpenExplain(k)"
                  >
                    <div class="th_wrapper">
                      <span
                        v-if="tableHeaderData[`__${k}__eye__icon`]"
                        class="th_icon_eye"
                        @click.stop="onClickEyeIcon(k)"
                      >
                        <i :class="['iconfont', hideFieldsForClient.includes(k) ? 'icon-close_eye' : 'icon-open_eye']" />
                      </span>
                      <span class="th_content" v-html="tableHeaderData[k]" />
                      <span v-if="tableHeaderData[`__${k}__problem__icon`]">
                        <i class="iconfont icon-common_problem" />
                      </span>
                    </div>
                    <span v-if="tableHeaderData[`__${k}__eye__icon`] && isShowEyeTips && k === ['irr_value', 'single_value', 'remark'].filter(k => !!tableHeaderData[k])[0]" class="th_eye_tips">
                      {{ hideFieldsForClient.includes(k) ? '转发不可见' : '转发可见' }}
                    </span>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div
            class="table_body"
          >
            <table :style="{ width: `${tableWidth}em`}">
              <tbody>
                <tr
                  v-for="record in tableBodyData"
                  :key="record.year"
                  :class="{
                    tr_border_right: record[`__${tableColumnKeys[tableColumnKeys.length - 1]}__rowspan`] === 0
                  }"
                >
                  <template v-for="k in tableColumnKeys">
                    <td
                      v-if="record[`__${k}__rowspan`] !== 0"
                      :key="k"
                      :class="{
                        active_color: record[`__${k}_color__flag`],
                        active_bg: record[`__${k}_bg__flag`],
                        with_tag: tableBodyData.some(e => e[`__${k}_purpose__tag`]),
                        writing_mode: record[`__${k}_writing_mode__flag`]
                      }"
                      :style="{
                        width: `${tableColumnWidths[k]}em`,
                        minWidth: `${tableColumnWidths[k]}em`,
                        maxWidth: `${tableColumnWidths[k]}em`
                      }"
                      :rowspan="record[`__${k}__rowspan`] || 1"
                    >
                      <div class="td_wrapper">
                        <span class="td_content" v-html="record[k]" />
                        <span v-if="tableBodyData.some(e => e[`__${k}_purpose__tag`])" class="td_flag">
                          <em v-if="record[`__${k}_purpose__tag`]">
                            {{ record[`__${k}_purpose__tag`] }}
                          </em>
                        </span>
                      </div>
                      <p v-if="record[`__${k}_multiple__tag`]" class="td_flag2">
                        <em>
                          {{ record[`__${k}_multiple__tag`] }}
                        </em>
                      </p>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>
<script>
import { get as _get, cloneDeep } from 'lodash'
import htmlToText from 'html-to-text'
import { isBxs } from 'base/config'
import { animate } from 'common/js/animate'

let eyeTimer = null
export default {
  props: {
    scene: {
      type: String,
      default: () => 'normal'
    },
    tableData: {
      type: Array,
      default: () => []
    },
    interestDetailWithRemark: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    curProductInterestData: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
    isScreenCaptureShow: Boolean
  },
  data () {
    const { scene } = this
    const types = ['normal', 'fixed']
    if (scene === 'export') {
      types.pop()
    }
    return {
      types, // normal | fixed
      isShowFixedTableHeader: null,
      isInvokeAnimation: null,
      isShowEyeIcon: isBxs && scene !== 'export',
      isShowEyeTips: true,
      skipNextScroll: false // 标志当前主动触发的类型,用于跳过因手动修改scrollLeft导致的@scroll响应
    }
  },
  computed: {
    isAllowScroll () {
      return this.scene !== 'export'
    },
    hideFieldsForClient () {
      return _get(this, 'formData.formValues.hideFieldsForClient') || []
    },
    remarkList () {
      const { curProductInterestData, interestDetailWithRemark, params } = this
      // 由于表格可以显示全部年龄，也可以只显示年龄的 remarkList 中的 startIndex、endIndex 需要转换为年龄
      // 年龄与索引的换算：i + insuredAge + startIndex  + 1
      const _insuredAge = _get(params, 'insuredAge') || 0
      const _interestStartIndex = _get(curProductInterestData, 'startIndex') || 0
      const _age = _insuredAge + _interestStartIndex  + 1
      const remarkList = cloneDeep(_get(interestDetailWithRemark, 'remarkList')) || []
      remarkList.forEach(detail => {
        detail.startAge = detail.startIndex + _age
        detail.endAge = detail.endIndex + _age
      })
      return remarkList
    },
    tableHeaderData () {
      const { scene, tableData, isShowEyeIcon } = this
      const header = cloneDeep(_get(tableData, '[0]') || {})
      for (const k in header) {
        let value = header[k] || ''
        header[k] = htmlToText.fromString(value)
        if (scene !== 'export') {
          if (value.match(/icon-common_problem/)) {
            header[`__${k}__problem__icon`] = true
          }
          if (['irr_value', 'single_value', 'remark'].includes(k)) {
            header[`__${k}__eye__icon`] = isShowEyeIcon
          }
        }
      }
      return header
    },
    tableBodyData () {
      const { scene, formData, tableData, remarkList } = this
      const tableBodyData = (cloneDeep(tableData) || []).slice(1)
      // 添加备注列
      if (remarkList.some(e => e.columnKey === 'remark')) {
        remarkList
          .filter(d => d.columnKey === 'remark')
          .forEach(d => {
            const { remark, startAge, endAge } = d
            const record0 = tableBodyData.find(e => e.age >= startAge && e.age <= endAge)
            if (record0) {
              record0.remark = remark
            }
          })
      }

      // 设置跨行
      const _displayAge = _get(formData, 'formValues.displayAge') || null
      remarkList.filter(detail => detail.columnKey !== 'title').forEach(detail => {
        const { columnKey, remark, subRemark, startAge, endAge } = detail
        const records = tableBodyData.filter(e => e.age >= startAge && e.age <= endAge)
        if (!records.length) {
          return
        }
        if (['baof'].includes(columnKey) && records.length <= 14) {
          return
        }
        // 兼容重叠
        if (records.some(record => record[`__${columnKey}__rowspan`] !== undefined)) {
          return
        }
        records.forEach((record, i) => {
          let _recordKey = columnKey
          // remarkList 中的 baof，在 dataList 中可能是 baof 或者 baofei
          if (_recordKey === 'baof' && !('baof' in record) && ('baofei' in record)) {
            _recordKey = 'baofei'
          }
          if (i === 0) {
            record[`__${_recordKey}__rowspan`] = records.length
            const _subRemark = subRemark || ''
            let _remark = remark || ''
            _remark = (_displayAge ? _remark : _remark + (_remark && _subRemark ? '<br /><br />' : '') + _subRemark)
            if (columnKey === 'baof') {
              // 文本竖排，计算高度、文字间距
              let _height = Math.max(350, records.length * 27)
              let _letterSpacing = _height <= 350 ? 0 : Math.floor((_height - 350) / _remark.length)
              _letterSpacing = Math.min(_letterSpacing, 15)
              _height = Math.min(window.innerHeight * 1.2, _height)
              _remark = _remark.split(/\s+/).map(e => `<em>${e}</em>`).join('')
              if (scene === 'export') {
                _letterSpacing *= 3
                _height *= 3
              }
              _remark = `<span class="writing_mode" style="height: ${_height}px; letter-spacing: ${_letterSpacing}px">${_remark}</span>`
              record[`__${_recordKey}_writing_mode__flag`] = true
            } else {
              _remark = _remark.replace(/\r\n/g, '<br /><br />')
            }
            record[_recordKey] = _remark
          } else {
            record[`__${_recordKey}__rowspan`] = 0
          }
        })
      })

      tableBodyData.forEach(record => {
        for (const k in record) {
          const value = record[k]
          if (['irr_value', 'single_value', 'policy_cash_grow_rate'].includes(k)) {
            record[k] = !Number.isNaN(Number(value)) ? value.toFixed(2) + '%' : value || '-'
          } else if (k === 'remark') {
            record[k] = record[k] || ''
          } else if (!k.match(/^__/)) {
            record[k] = value || value === 0 ? value : '-'
          }
          if (record[`${k}__flag`]) {
            record[`__${k}_multiple__tag`] = record[`${k}__flag`]
            delete record[`${k}__flag`]
            record[`__${k}_color__flag`] = true
          }
          if (!(record.age % 10)) {
            record[`__${k}_bg__flag`] = true
          }
        }
      })
      return tableBodyData
    },
    tableColumnKeys () {
      const keys = Object.keys(this.tableHeaderData)
      return keys.filter(k => !k.match(/(__tag|__flag|__icon|__rowspan)$/))
    },
    tableColumnWidths () {
      const { scene, tableColumnKeys, tableHeaderData, tableBodyData, $el } = this
      const textLengthObj = {}
      tableColumnKeys.forEach(k => {
        tableBodyData.forEach((record) => {
          if (record[`__${k}__rowspan`] > 1) {
            return
          }
          const value = record[k] === 0 ? '0' : (record[k] || '')
          const str = htmlToText.fromString(value)
          const length = this.caclStringCount(str)
          textLengthObj[k] = Math.max((textLengthObj[k] || 0), length)
        })
      })
      const widthList = tableColumnKeys.map(k => ({
        key: k,
        width: textLengthObj[k]
      }))
      widthList.forEach(ele => {
        ele.width += 1.5
        ele.width = Math.max(ele.width, 3)
        const hasMultipleTag = tableBodyData.some(record => record[`__${ele.key}_multiple__tag`])
        const hasPurposeTag = tableBodyData.some(record => record[`__${ele.key}_purpose__tag`])
        const purposeTagStrCount = tableBodyData.reduce((num, record) => Math.max(num, this.caclStringCount(record[`__${ele.key}_purpose__tag`])), 0)
        if (!hasMultipleTag && hasPurposeTag) {
          ele.width += Math.max(2.2, (purposeTagStrCount + 1) * 0.75)
        }
        if (scene !== 'export') {
          const hasProblemIcon = _get(tableHeaderData, `__${ele.key}__problem__icon`)
          if (hasProblemIcon) {
            ele.width += 1.5
          }
          const hasEyeIcon = ['irr_value', 'single_value'].includes(ele.key)
          if (hasEyeIcon) {
            ele.width += 1.5
          }
        }
        if (ele.key === 'remark') {
          ele.width = 9
        }
        ele.width = Math.min(ele.width, 9)
      })
      const tableWidth = widthList.reduce((w, ele) => w + ele.width, 0)
      if ($el && $el.querySelector) {
        let minTableWidth = window.innerWidth
        const tableBodyDom = $el.querySelector('.normal_table_main')
        if (tableBodyDom) {
          minTableWidth = tableBodyDom.clientWidth
        }
        if (scene === 'export') {
          minTableWidth = Math.min(window.innerWidth * 327 / 375, minTableWidth)
        }
        minTableWidth /= (scene === 'export' ? 11 : 12)

        // 表格实际宽度小屏宽时，除年度、年龄外的列均分剩于宽度
        let surplusWidth = (tableWidth < minTableWidth ? minTableWidth - tableWidth : 0)
        if (surplusWidth) {
          const averageWidth = surplusWidth / (widthList.length - 2)
          let consumeWidth = 0
          widthList.forEach((ele, i, arr) => {
            if (['year', 'age'].includes(ele.key)) {
              return
            }
            if (i === arr.length - 1) {
              ele.width += (surplusWidth - consumeWidth)
              return
            }
            ele.width += averageWidth
            consumeWidth += averageWidth
          })
        }
      }

      return widthList.reduce((obj, ele) => {
        obj[ele.key] = ele.width
        return obj
      }, {})
    },
    tableWidth () {
      return Object.keys(this.tableColumnWidths).reduce((w, k) => w + this.tableColumnWidths[k], 0)
    }
  },
  watch: {
  },
  mounted () {
    const self = this
    window.addEventListener('scroll', self.showFixedTabHeader)
    self.autoMoving()
    self.showFixedTabHeader()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', self.showFixedTabHeader)
  },
  methods: {
    caclStringCount (str = '') {
      const ChineseChars = (str + '').match(/[^0-9a-zA-Z.]/g) || ''
      const nonChineseChars = (str + '').match(/[0-9a-zA-Z.]/g) || ''
      return ChineseChars.length + nonChineseChars.length * 0.5
    },
    showFixedTabHeader () {
      const { isAllowScroll, $el } = this
      if (!isAllowScroll || !($el && $el.querySelector)) {
        return
      }
      const tableMainDom = $el.querySelector('.normal_table_main')
      const rect = tableMainDom && tableMainDom.getBoundingClientRect()
      if (!rect) {
        return
      }
      const tableHeaderDom = tableMainDom && tableMainDom.querySelector('.interest_form .fixed_header')
      const tableHeaderHeight = tableHeaderDom ? tableHeaderDom.clientHeight : 46
      this.isShowFixedTableHeader = rect.top <= tableHeaderHeight && rect.bottom >= tableHeaderHeight

      if (this.isShowFixedTableHeader) {
        this.$nextTick(() => {
          const scrollHeaderDom = tableMainDom && tableMainDom.querySelector('.fixed_header')
          scrollHeaderDom && (scrollHeaderDom.scrollLeft = tableMainDom.scrollLeft)
        })
      }
    },
    autoMoving () {
      if (!this.isAllowScroll) {
        return
      }
      if (this.isInvokeAnimation) {
        return
      }
      this.isInvokeAnimation = true

      const $tableWrap = _get(this.$refs['tableWrap-normal'], '[0]')
      const $fixedWrap = _get(this.$refs['headerWrap-normal-fixed'], '[0]')
      const animateCallback = (value) => {
        $tableWrap && ($tableWrap.scrollLeft = value)
        $fixedWrap && ($fixedWrap.scrollLeft = value)
      }
      animate({
        pri: 0,
        end: 30,
        duration: 400,
        callback: animateCallback,
        endCallback: () => {
          animate({
            pri: 30,
            end: 0,
            duration: 400,
            callback: animateCallback,
            endCallback: () => {
              this.isInvokeAnimation = false
            }
          })
        }
      })
    },
    onClickOpenExplain (k) {
      if (!this.isAllowScroll) {
        return
      }
      const bool = _get(this, `tableHeaderData[__${k}__problem__icon]`) || ''
      if (bool) {
        this.$emit('openExplain')
      }
    },
    onClickEyeIcon (key) {
      if (!this.isAllowScroll) {
        return
      }
      const _formValues = _get(this.formData, 'formValues')
      if (_formValues.hideFieldsForClient.includes(key)) {
        _formValues.hideFieldsForClient = _formValues.hideFieldsForClient.filter(k => k !== key)
      } else {
        _formValues.hideFieldsForClient.push(key)
      }
      this.$emit('update', {
        hideFieldsForClient: _formValues.hideFieldsForClient
      })

      this.isShowEyeTips = true
      clearTimeout(eyeTimer)
      eyeTimer = setTimeout(() => {
        this.isShowEyeTips = false
      }, 3000)
    },
    handleScroll (name, e) {
      let relatedWrap = null
      if (name === 'header') {
        relatedWrap = this.$refs['tableWrap-normal']
      } else if (name === 'table') {
        relatedWrap = this.$refs['headerWrap-normal-fixed']
      }

      if (relatedWrap && relatedWrap[0] && relatedWrap[0] !== e.target) {
        if (this.skipNextScroll) {
          this.skipNextScroll = false
          return
        }
        relatedWrap[0].scrollLeft = e.target.scrollLeft
        // console.log(name, e.target.classNames)
        this.skipNextScroll = true
      }
    }
  }
}
</script>
<style>
@import './interest-table.css';
</style>
